import { render, staticRenderFns } from "./ProjectsCompoent.vue?vue&type=template&id=2db69552"
import script from "./ProjectsCompoent.vue?vue&type=script&lang=js"
export * from "./ProjectsCompoent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports